import { InjectionToken, PipeTransform } from '@angular/core';
import { BrazilianCurrencyPipe } from '@brunsker/libs/core/utils/brazilian-currency/src/lib/pipes/brazilian-currency/brazilian-currency.pipe';

export const CURRENCY_PIPE = new InjectionToken<BrazilianCurrencyPipe>('brazilianCurrency');
export const DATE_PIPE = new InjectionToken<PipeTransform>('date');
